import { render, staticRenderFns } from "./PostingTOModal.vue?vue&type=template&id=5c2efe5e&scoped=true&"
import script from "./PostingTOModal.vue?vue&type=script&lang=js&"
export * from "./PostingTOModal.vue?vue&type=script&lang=js&"
import style0 from "./PostingTOModal.vue?vue&type=style&index=0&id=5c2efe5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2efe5e",
  null
  
)

export default component.exports